<div class="contact-wave" aria-hidden="true"></div>
<div class="fill">
  <div class="container wrapper">
    <div class="text-center py-4">
      <h2>Contact a Pool & Hot Tub Expert</h2>
    </div>
    <div class="large-input pb-5">
      <form [formGroup]="contactUsForm">
        <mat-form-field class="my-3">
          <input type="text"
            placeholder="Email Address"
            aria-label="Email"
            matInput
            formControlName="email"
            required>
            @if (email.invalid) {
              <mat-error>{{getErrorMessage()}}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="mb-3">
            <textarea
              class="message-area"
              placeholder="Message"
              aria-label="Message"
              matInput
              formControlName="message"
              required>
            </textarea>
            @if (message.invalid) {
              <mat-error>You must enter a value</mat-error>
            }
          </mat-form-field>
          <div class="d-flex justify-content-center">
            <button class="primary w-75" (click)="submit()">
              @if (!(spinner$ | async)?.show) {
                Contact an Expert
              }
              @if ((spinner$ | async)?.show) {
                <div class="d-flex justify-content-center w-100">
                  <span class="spinner">
                    <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="small" color="#fff" type="ball-spin-clockwise" [fullScreen]="false"></ngx-spinner>
                  </span>
                </div>
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
